import { Component, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { FormUtil } from '../../utils';
import { AbstractControlValueAccessorComponent } from '../../abstracts/abstract-control-value-accessor.component';
import { DateConverter } from '../../converters/date.converter';

@Component({
    selector: 'px-date',
    templateUrl: './date.component.html',
})
export class DateComponent extends AbstractControlValueAccessorComponent implements ControlValueAccessor {
    @Input() type: 'full' | 'monthYear' = 'full';

    constructor(@Optional() @Self() public ngControl: NgControl) {
        super();
        if (this.ngControl != null) {
            this.ngControl.valueAccessor = this;
        }
    }

    get formControl() {
        return this.ngControl ? this.ngControl.control : null;
    }

    get isRequired() {
        return this.formControl && FormUtil.hasValidatorKey(this.formControl, 'required');
    }

    get hasError() {
        return this.formControl && this.formControl.errors;
    }

    get hasErrorAndIsTouched() {
        return this.hasError && this.formControl.touched;
    }

    get errorMessage() {
        return FormUtil.getFirstError(this.formControl).replace(
            '#LABEL',
            this.errorLabel ? this.errorLabel : 'Dieses Feld'
        );
    }

    focusOut() {
        if (this.type === 'full') {
            this.writeValue(DateConverter.convert(this.value));
        } else if (this.type === 'monthYear') {
            this.writeValue(DateConverter.convertMonthYear(this.value));
        }
        this.propagateTouch();
    }
}
